import { render } from "./GridPermissions.vue?vue&type=template&id=3308e313"
import script from "./GridPermissions.vue?vue&type=script&lang=js"
export * from "./GridPermissions.vue?vue&type=script&lang=js"

import "./GridPermissions.vue?vue&type=style&index=0&id=3308e313&lang=scss"

import exportComponent from "/builds/linkbuilding-crm/crm-v2-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__